if (document.querySelector('#gift-card-recipient #recipient-check') != null) {
    document.querySelector('#gift-card-recipient #recipient-check').addEventListener('change', function(e) {
        if (this.checked) {
            document.querySelector('#gift-card-recipient #gift-card-recipient-form').style.display = 'block';

            document.querySelector('#gift-card-recipient #recipient-email').value = '';
            document.querySelector('#gift-card-recipient #recipient-email').name = 'properties[Recipient email]';
            document.querySelector('#gift-card-recipient #recipient-name').value = '';
            document.querySelector('#gift-card-recipient #recipient-name').name = 'properties[Recipient name]';
            document.querySelector('#gift-card-recipient #recipient-message').value = '';
            document.querySelector('#gift-card-recipient #recipient-message').name = 'properties[Message]';
        }
        else {
            document.querySelector('#gift-card-recipient #gift-card-recipient-form').style.display = 'none';

            document.querySelector('#gift-card-recipient #recipient-email').value = '';
            document.querySelector('#gift-card-recipient #recipient-email').name = '';
            document.querySelector('#gift-card-recipient #recipient-name').value = '';
            document.querySelector('#gift-card-recipient #recipient-name').name = '';
            document.querySelector('#gift-card-recipient #recipient-message').value = '';
            document.querySelector('#gift-card-recipient #recipient-message').name = '';
        }
    });
}